import { createFileRoute } from '@tanstack/react-router';
import { CounterpartForm } from '@/pages/registry/counterparts/form/counterpart-form';
import { PROTECTED, REGISTRY } from '@/lib/constants/routes';

export const Route = createFileRoute(
  '/protected/_layout/registry/_layout/counterparts/new'
)({
  component: () => <CounterpartForm returnUrl={`${PROTECTED}${REGISTRY}`} />,
});
